import React, { useMemo } from "react";
import { Col, Container, Row } from "reactstrap";

import SearchBar from "./search-bar";
import { routes } from "@/utils/routes";
import HelpBreadcrumbs from "./help-breadcrumbs";
import {
  CollectionType,
  CategoryKeys,
  CategoryType,
  ArticleKeys,
  HelpArticle,
} from "@/@types/help/Articles";
import ContentSection from "./content-section";
import DirectorySection from "./directory-section";
import HelpVideo from "./help-video";
import { Sidebar } from "./article-sidebar";

interface Props {
  collection: CollectionType;
  category?: { key: CategoryKeys; value: CategoryType };
  article: { key: ArticleKeys; value: HelpArticle };
}

const ArticleMain = ({ collection, category, article }: Props) => {
  const items: any = useMemo(() => {
    const items = [
      {
        disabled: true,
        title: article.value?.title,
        partialLink: article.value?.link,
      },
    ];

    if (category) {
      items.unshift({
        disabled: true,
        title: category.value?.title,
        partialLink: category.value?.link,
      });
    }

    if (collection) {
      items.unshift({
        disabled: false,
        title: collection?.title,
        partialLink: collection?.link,
      });
    }
    return items;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderChildComponents = (article: HelpArticle) => {
    return article?.data?.map((d, i) => {
      switch (d.type) {
        case "info":
          return (
            <div key={`${d.type}x${i}`}>
              <ContentSection content={d} />
            </div>
          );
        case "directory":
          return (
            <div key={`${d.type}x${i}`}>
              <DirectorySection content={d} />
            </div>
          );
        case "faq":
          return <div key={`${d.type}x${i}`}>{d.data}</div>;
        case "video":
          return (
            <div key={`${d.type}x${i}`}>
              <HelpVideo {...d.data} repeat={false} />
            </div>
          );
        default:
          return <></>;
      }
    });
  };

  return (
    <main>
      <Container className="mb-3">
        <SearchBar basePath={routes.help} />
        <HelpBreadcrumbs basePath={routes.help} items={items} />
        <hr />
        <Row>
          <Col className="border-end mb-3" xs={12} md={4} lg={3}>
            <h6 className="text-secondary fw-bold border-bottom pb-2">
              Article Directory
            </h6>
            <Sidebar
              collectionId={collection.link}
              categoryId={category?.key}
            />
          </Col>
          <Col className="pb-5 mb-5" xs={12} md={8} lg={9}>
            <small className="fw-bold text-darkblue">
              {category?.value?.title ?? "No Category"}
            </small>
            <h5 className="fw-bold"> {article?.value?.title}</h5>
            <hr />
            {renderChildComponents(article.value)}
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default ArticleMain;
